/** OAuth scopes for Drive read + Picker (backend stores refresh token). */
export const GOOGLE_DRIVE_OAUTH_SCOPES = [
  "https://www.googleapis.com/auth/drive.file",
  // Needed so Google returns user identity (sub/email) for token storage.
  "openid",
  "email",
  "profile",
].join(" ");

export interface DriveFileRef {
  id: string;
  name: string;
  mimeType?: string;
}
